import { section } from '@/glow';
import { AnimateFeaturedCollection } from '@/lib/animation';
import { qs } from '@fluorescent/dom';
import Carousel from '@/lib/carousel';

import AnimateProductItem from '@/lib/product-item';

const selectors = {
  slider: '[data-slider]'
};

section('featured-collection', {
  onLoad() {
    this.sliderElement = qs(selectors.slider, this.container);
    this.columns = parseInt(this.container.dataset.columns);
    this.sliderElement.style.opacity = 0;
    const carouselWraps = this.container.dataset.carouselWraps === 'true';
    this.carousel = Carousel(this.container, 'featured-collection', {
      wrapAround: carouselWraps,
      onReady: () => {
        this.animateProductItem = AnimateProductItem(this.container);
        this.AnimateFeaturedCollection = AnimateFeaturedCollection(this.container);
      }
    });
  },

  onUnload() {
    this.carousel.destroy();
    this.animateProductItem && this.animateProductItem.destroy();
    this.AnimateFeaturedCollection?.destroy();
  },
});
